/**
 * generated-images — in-memory registry of AI-generated images pushed from the
 * embed (IMAGE_GENERATED). The chat's file URLs (usable.dev/files/…) are not
 * CORS-readable from the task pane, but the embed pushes the raw bytes to the
 * parent the moment an image is generated — so insert_image / compose_slide
 * can use "the image you just generated" with zero fetching.
 *
 * Session-scoped by design: images are for immediate "put that on the slide"
 * flows, not persistence (the deck itself is the persistence).
 */
import type { GeneratedImagePayload } from "@usable/office-embed";

const MAX_KEPT = 5;

/** Newest first. */
const images: GeneratedImagePayload[] = [];

export function recordGeneratedImage(payload: GeneratedImagePayload): void {
  if (!payload?.base64) return;
  // Re-generation can re-emit the same fileId — keep the newest copy only.
  const existing = images.findIndex((i) => i.fileId === payload.fileId);
  if (existing !== -1) images.splice(existing, 1);
  images.unshift(payload);
  if (images.length > MAX_KEPT) images.length = MAX_KEPT;
}

/** Latest generated image, or by fileId when given. Null when none exist. */
export function getGeneratedImage(fileId?: string): GeneratedImagePayload | null {
  if (fileId) return images.find((i) => i.fileId === fileId) ?? null;
  return images[0] ?? null;
}

/** Metadata (no bytes) for tool results / debugging. Newest first. */
export function listGeneratedImages(): Array<{ fileId: string; mimeType: string; prompt?: string }> {
  return images.map(({ fileId, mimeType, prompt }) => ({ fileId, mimeType, prompt }));
}

/** Test-only. */
export function __resetGeneratedImagesForTests(): void {
  images.length = 0;
}
